import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  lastDeal: {
    minHeight: theme.spacing(8),
  },
  divider: {
    margin: theme.spacing(1, 0),
  },
}));
